import api from '../../store/config/api';
import { WEBHOOK as SCHEMA } from '../../schemas';

export const [
  GET_WEBFORM,
  GET_WEBFORM_REQUEST,
  GET_WEBFORM_SUCCESS,
  GET_WEBFORM_FAILURE
] = api.buildTypes('GET_WEBFORM');

export function getWebform({ teamName, webhookname }) {
  return {
    type: GET_WEBFORM,
    payload: {
      url: `teams/${teamName}/forms/${webhookname}`,
      schema: SCHEMA
    }
  };
}

export const [
  CREATE_WEBFORM,
  CREATE_WEBFORM_REQUEST,
  CREATE_WEBFORM_SUCCESS,
  CREATE_WEBFORM_FAILURE
] = api.buildTypes('CREATE_WEBFORM');

export function createWebform({ webform, teamName }) {
  const url = `teams/${teamName}/webhooks`;

  const webhook = Object.assign({}, webform, {
    appID: 'triggers/on-web-form/v1'
  });

  return {
    type: CREATE_WEBFORM,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: webhook
      }
    }
  };
}

export const [
  UPDATE_WEBFORM,
  UPDATE_WEBFORM_REQUEST,
  UPDATE_WEBFORM_SUCCESS,
  UPDATE_WEBFORM_FAILURE
] = api.buildTypes('UPDATE_WEBFORM');

export function updateWebform({ webform, teamName }) {
  const webhook = Object.assign({}, webform, {
    appID: 'triggers/on-web-form/v1'
  });

  return {
    type: UPDATE_WEBFORM,
    payload: {
      url: `teams/${teamName}/webhooks/${webhook.webhookID}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: webhook
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/webform.js